var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "compare-table" },
    [
      _c(
        "el-tabs",
        {
          on: { "tab-click": _vm.handleClick },
          model: {
            value: _vm.activeName,
            callback: function($$v) {
              _vm.activeName = $$v
            },
            expression: "activeName"
          }
        },
        [
          _vm.callBidDocInfo.goodsFlag
            ? _c("el-tab-pane", { attrs: { label: "商品", name: "goods" } }, [
                _c("table", { staticClass: "custom-tbl compare-box" }, [
                  _c("thead", { staticClass: "head operate-table" }, [
                    _c(
                      "tr",
                      { staticClass: "row" },
                      [
                        _c("th", { staticClass: "align-left" }, [
                          _c("div", { staticClass: "setbox" }, [
                            _c(
                              "p",
                              {
                                staticClass: "ellipsis-1",
                                attrs: { title: _vm.callBidDocInfo.title }
                              },
                              [_vm._v(_vm._s(_vm.callBidDocInfo.title))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.bidParityList, function(bidParity, index) {
                          return _c("th", [
                            _c("div", { staticClass: "compare-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "ellipsis-1",
                                  attrs: { title: bidParity.merchantName }
                                },
                                [_vm._v(_vm._s(bidParity.merchantName))]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("总报价（元）")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price fr" }, [
                                _vm._v(_vm._s(bidParity.offerPrice || "无"))
                              ]),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticClass: "close-icon",
                                  on: {
                                    click: function($event) {
                                      _vm.removeBidParity(index)
                                    }
                                  }
                                },
                                [_vm._v("×")]
                              )
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { staticClass: "body content-table" },
                    _vm._l(_vm.callGoodsMap, function(value, key) {
                      return _c(
                        "tr",
                        { staticClass: "row" },
                        [
                          _c("td", [
                            _c("div", { staticClass: "compare-name" }, [
                              _c("p", { staticClass: "font12" }, [
                                _vm._v(_vm._s(value.name))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "font12" }, [
                                _vm._v(
                                  "\n                                平均价（元）"
                                ),
                                _c("span", { staticClass: "font-red" }, [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        value.sumPrice / value.sumQuantity
                                      ).toFixed(2)
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.bidGoodsMap[key], function(bidGoods) {
                            return _c("td", {}, [
                              bidGoods != null
                                ? _c("div", { staticClass: "compare-info" }, [
                                    _c("div", { staticClass: "textbox" }, [
                                      _c("div", { staticClass: "image" }, [
                                        _c("img", {
                                          attrs: {
                                            src: bidGoods.skuDefaultImageUrl
                                          }
                                        })
                                      ]),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text",
                                          staticStyle: { "padding-left": "5px" }
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "align-left ellipsis-1",
                                              attrs: { title: bidGoods.name }
                                            },
                                            [_vm._v(_vm._s(bidGoods.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "align-left" },
                                            [_vm._v(_vm._s(bidGoods.brandName))]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pricebox" }, [
                                      _c(
                                        "div",
                                        { staticClass: "price-group" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("报价（元）：")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "value",
                                              class: {
                                                "font-red":
                                                  bidGoods.price >
                                                  value.sumPrice /
                                                    value.sumQuantity,
                                                "font-green":
                                                  bidGoods.price <=
                                                  value.sumPrice /
                                                    value.sumQuantity
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    bidGoods.price.toFixed(2)
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      )
                                    ])
                                  ])
                                : _c("div", { staticClass: "compare-info" })
                            ])
                          })
                        ],
                        2
                      )
                    })
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _vm.callBidDocInfo.servcFlag
            ? _c("el-tab-pane", { attrs: { label: "服务", name: "servc" } }, [
                _c("table", { staticClass: "custom-tbl compare-box" }, [
                  _c("thead", { staticClass: "head operate-table" }, [
                    _c(
                      "tr",
                      { staticClass: "row" },
                      [
                        _c("th", { staticClass: "align-left" }, [
                          _c("div", { staticClass: "setbox" }, [
                            _c(
                              "p",
                              {
                                staticClass: "ellipsis-1",
                                attrs: { title: _vm.callBidDocInfo.title }
                              },
                              [_vm._v(_vm._s(_vm.callBidDocInfo.title))]
                            )
                          ])
                        ]),
                        _vm._v(" "),
                        _vm._l(_vm.bidParityList, function(bidParity, index) {
                          return _c("th", [
                            _c("div", { staticClass: "compare-item" }, [
                              _c(
                                "a",
                                {
                                  staticClass: "ellipsis-1",
                                  attrs: { title: bidParity.merchantName }
                                },
                                [_vm._v(_vm._s(bidParity.merchantName))]
                              ),
                              _vm._v(" "),
                              _c("span", [_vm._v("总报价（元）")]),
                              _vm._v(" "),
                              _c("span", { staticClass: "price fr" }, [
                                _vm._v(_vm._s(bidParity.offerPrice || "无"))
                              ]),
                              _vm._v(" "),
                              _c(
                                "i",
                                {
                                  staticClass: "close-icon",
                                  on: {
                                    click: function($event) {
                                      _vm.removeBidParity(index)
                                    }
                                  }
                                },
                                [_vm._v("×")]
                              )
                            ])
                          ])
                        })
                      ],
                      2
                    )
                  ]),
                  _vm._v(" "),
                  _c(
                    "tbody",
                    { staticClass: "body content-table" },
                    _vm._l(_vm.callServcsMap, function(value, key) {
                      return _c(
                        "tr",
                        { staticClass: "row" },
                        [
                          _c("td", [
                            _c("div", { staticClass: "compare-name" }, [
                              _c("p", { staticClass: "font12" }, [
                                _vm._v(_vm._s(value.name))
                              ]),
                              _vm._v(" "),
                              _c("p", { staticClass: "font12" }, [
                                _vm._v(
                                  "\n                                平均价（元）"
                                ),
                                _c("span", { staticClass: "font-red" }, [
                                  _vm._v(
                                    _vm._s(
                                      (
                                        value.sumPrice / value.sumQuantity
                                      ).toFixed(2)
                                    )
                                  )
                                ])
                              ])
                            ])
                          ]),
                          _vm._v(" "),
                          _vm._l(_vm.bidServcsMap[key], function(bidServc) {
                            return _c("td", {}, [
                              bidServc != null
                                ? _c("div", { staticClass: "compare-info" }, [
                                    _c("div", { staticClass: "textbox" }, [
                                      _c(
                                        "div",
                                        {
                                          staticClass: "text",
                                          staticStyle: { "padding-left": "5px" }
                                        },
                                        [
                                          _c(
                                            "p",
                                            {
                                              staticClass:
                                                "align-left ellipsis-1",
                                              attrs: { title: bidServc.name }
                                            },
                                            [_vm._v(_vm._s(bidServc.name))]
                                          ),
                                          _vm._v(" "),
                                          _c(
                                            "p",
                                            { staticClass: "align-left" },
                                            [_vm._v(_vm._s(bidServc.brandName))]
                                          )
                                        ]
                                      )
                                    ]),
                                    _vm._v(" "),
                                    _c("div", { staticClass: "pricebox" }, [
                                      _c(
                                        "div",
                                        { staticClass: "price-group" },
                                        [
                                          _c("div", { staticClass: "label" }, [
                                            _vm._v("报价（元）：")
                                          ]),
                                          _vm._v(" "),
                                          _c(
                                            "div",
                                            {
                                              staticClass: "value",
                                              class: {
                                                "font-red":
                                                  bidServc.price >
                                                  value.sumPrice /
                                                    value.sumQuantity,
                                                "font-green":
                                                  bidServc.price <=
                                                  value.sumPrice /
                                                    value.sumQuantity
                                              }
                                            },
                                            [
                                              _c("span", [
                                                _vm._v(
                                                  _vm._s(
                                                    bidServc.price.toFixed(2)
                                                  )
                                                )
                                              ])
                                            ]
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "p",
                                        {
                                          staticClass:
                                            "align-right swb-btn-link display-block font12"
                                        },
                                        [_vm._v("更多")]
                                      )
                                    ])
                                  ])
                                : _c("div", { staticClass: "compare-info" })
                            ])
                          })
                        ],
                        2
                      )
                    })
                  )
                ])
              ])
            : _vm._e()
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-9e1e248a", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-9e1e248a","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/compo/callbid/BidParity.vue
// module id = 3319
// module chunks = 0